module.exports = __webpack_public_path__ + "img/team.e02ffe22.jpeg";